<template>
  <div class="read-also">
    <div class="read-also__header">
      <div class="read-also__title">{{ readAlso.title }}</div>
      <div class="read-also__emoji">{{ readAlso.emoji }}</div>
    </div>
    <div class="articles">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="articles__item"
      >
        <BHLink
          class="articles__item-text"
          :href="item.url"
          target="_blank"
          @click="sendAnalytics(item, index + 1)"
        >
          {{ item.title }}
        </BHLink>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import BHLink from '~/components/BHLink.vue';
  import type { IContentReadAlso, TReadAlso, TReadAlsoItem } from '~/types/components/BaseReadAlso';
  import getSlugFromUrl from '~/utils/getSlugFromUrl';

  export default defineNuxtComponent({
    components: {
      BHLink,
    },

    inject: {
      eventCategory: {
        default() {
          return () => '';
        },
      },

      isEndArticleReadAlso: {
        default() {
          return () => '';
        },
      },
    },

    props: {
      elem: {
        type: Object as PropType<IContentReadAlso>,
        required: true,
      },
    },

    computed: {
      readAlso(): TReadAlso {
        return this.elem.attributes;
      },

      items(): Array<TReadAlsoItem> {
        return this.readAlso.items.slice(0, 5);
      },

      currentslug(): string {
        return getSlugFromUrl(this.$route.fullPath);
      },
    },

    methods: {
      sendAnalytics(item: TReadAlsoItem, serialNumber: number) {
        // @ts-expect-error injected functions are not typed in options API
        const eventElement = this.isEndArticleReadAlso() ? 'в конце статьи' : 'в теле статьи';
        const slugReferrer = getSlugFromUrl(item.url);

        this.$sendYandexMetrika({
          level1: 'Клик_Читайте также',
          level4: slugReferrer,
          level5: serialNumber.toString(),
          level6: eventElement,
        });
      },
    },
  });
</script>

<style lang="scss" scoped>
  .read-also {
    border: 1px solid $border-color--2;
    border-top: 4px solid $default-color--1;
    border-radius: 0px 0px 32px 32px;
    padding: 16px 16px 24px;
    @include tablet {
      padding: 24px 24px 32px;
    }
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &__title {
      word-break: break-word;
      font-family: $headline-font--1;
      font-size: 18px;
      line-height: 28px;
      font-weight: 400;
      @include big-tablet {
        font-size: 22px;
        line-height: 32px;
      }
    }
    &__emoji {
      font-size: 24px;
    }
  }

  .articles {
    margin-top: 16px;
    &__item {
      &:not(:first-child) {
        margin-top: 16px;
      }
      &-text {
        @include link-styles;
        word-break: break-word;
        font-family: $text-font--1;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        @include big-tablet {
          font-size: 18px;
          line-height: 28px;
          font-weight: 400;
        }
      }
    }
  }
</style>
